import styled from "@emotion/styled";

export const FormField = styled.div`
  margin-top: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &.language {
    flex-direction: column;
  }

  &.language .language-radio-group {
    flex-direction: row;
  }

  & .fetch-button {
    padding: 2rem 4.8rem;
  }
`;
